export default function TitleFormWithEdit({ title, edit, onChangeEdit, showButton }) {
  return (
    <div className="my-4 d-flex justify-content-between align-items-center">
      <div>
        <h1>{title}</h1>
      </div>
      {showButton && (
        <div className="d-flex align-items-center mb-0 gap-5px">
          <div>
            Editar
          </div>
          <label className="custom-toggle" style={{ marginBottom: 0 }}>
            <input type="checkbox" checked={edit} onChange={e => onChangeEdit && onChangeEdit(e.target.checked)} />
            <span className="custom-toggle-slider rounded-circle" />
          </label>
        </div>
      )}
    </div>
  )
}